import React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

export const ScrollToTopOnNav = withRouter(
    class extends React.Component<RouteComponentProps<{}>, {}> {
        componentDidUpdate(prevProps: RouteComponentProps<{}>) {
            if (
                typeof window !== 'object' ||
                this.props.location === prevProps.location ||
                this.props.history.action !== 'PUSH'
            ) {
                return
            }

            window.scrollTo(0, 0)
        }

        render() {
            if (!this.props.children) {
                return null
            }
            return React.Children.only(this.props.children)
        }
    },
)
